import "highcharts/modules/drilldown";

import { Card, Spin } from "antd";
import Highcharts from "highcharts";
import HighchartsReact from "highcharts-react-official";
import { Fragment, useEffect, useRef } from "react";

export const PopularSoldView = ({ data, loading }: any) => {
  const chartRef = useRef<HighchartsReact.RefObject>(null);

  const barColors = [
    "#E55050",
    "#008048",
    "#35B1E8",
    "#FFA51F",
    "#FEBEC8",
    "#4C5167",
    "#008044",
    "#35B1E8",
  ];

  // ✅ Main series
  const mainSeriesData =
    data?.graphDataList?.map((cat: any) => ({
      name: cat.CategoryName,
      y: cat.TotalCount,
      drilldown: cat.TotalCount > 0 ? cat.CategoryName : undefined,
    })) || [];

  // ✅ Drilldown series
  const drilldownSeries =
    data?.graphDataList
      ?.filter((cat: any) => cat.TotalCount > 0)
      .map((cat: any) => ({
        id: cat.CategoryName,
        name: cat.CategoryName,
        type: "column",
        colorByPoint: true, // ✅ ensures barColors apply per point
        colors: barColors,
        data:
          data.drilldownList
            ?.filter((item: any) => item.CategoryId === cat.CategoryId)
            .map((item: any) => ({
              name: item.ItemName,
              y: item.TotalCount,
              revenue: item.TotalRevenue,
            })) || [],
      })) || [];

  const chartOptions: Highcharts.Options = {
    chart: {
      type: "column",
      backgroundColor: "transparent",
    },
    title: {
      text: "Popular Items Sold",
      style: {
        color: "#000", // ✅ title in black
        fontWeight: "bold",
      },
    },
    xAxis: {
      type: "category",
      labels: {
        style: {
          color: "#000", // ✅ x labels black
          fontSize: "11px",
        },
      },
    },
    yAxis: {
      title: { text: "Total Sold", style: { fontSize: "11px", color: "black" } },
      labels: { style: { fontSize: "11px", color: "black" } },
    },
    credits: {
      enabled: false,
    },
    legend: {
      enabled: false,
    },
    colors: barColors, // ✅ alternating bar colors
    plotOptions: {
      series: {
        borderWidth: 0,
        dataLabels: {
          enabled: true,
          style: {
            textOutline: "none",
            color: "#000", // ✅ data labels black
            fontWeight: "bold",
          },
        },
      },
    },
    tooltip: {
      formatter: function (this: any) {
        if (this.point.revenue !== undefined) {
          return `<b>${this.point.name}</b><br>Total Sold: ${this.y}<br>Total Revenue: ${this.point.revenue}`;
        }
        
return `<b>${this.point.name}</b><br>Total Sold: ${this.y}`;
      },
    },
    series: [
      {
        name: "Items",
        type: "column",
        colorByPoint: true, // ✅ apply alternating colors
        data: mainSeriesData,
      },
    ],
    drilldown: {
      series: drilldownSeries,
      activeAxisLabelStyle: {
        textDecoration: "none",
        color: "black"   // 🔹 Sets label color to black
      },
      activeDataLabelStyle: {
        textDecoration: "none",
        color: "black"   // 🔹 Sets data label color to black
      }
    }
  };

  useEffect(() => {
    const chart = chartRef.current?.chart;
    if (chart) {
      if (loading) {
        chart.showLoading("Loading data...");
      } else {
        chart.hideLoading();
      }
    }
  }, [loading]);

  return (
    <Fragment>
      <Card>
        <Spin spinning={loading}>
          <HighchartsReact
            ref={chartRef}
            highcharts={Highcharts}
            options={chartOptions}
          />
        </Spin>
      </Card>
    </Fragment>
  );
};
